import React from 'react';
import LinkIcon from '@mui/icons-material/Link';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  {
    key: 'rawText',
    label: 'Raw Import Text',
    required: true,
    helperText: 'Exact region text as it appears in the source file (matched case-insensitively).',
  },
  {
    key: 'regionId',
    label: 'Region',
    required: true,
    type: 'reference',
    referenceApiPath: '/api/regions',
    displayKey: 'regionName',
  },
];

// Admin view of RegionAlias — same purpose as ProductAliasManagement, for
// the Region field instead of Product.
const RegionAliasManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Region Map"
    icon={<LinkIcon />}
    apiPath="/api/region-aliases"
    fields={fields}
    entityLabel="Region Alias"
    softDelete={false}
  />
);

export default RegionAliasManagement;
